import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import menu from './modules/menu'
import user from './modules/user'
import app from './modules/app'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    menu,
    user,
    app
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js